import { TestLocators } from 'constants/Locators';

import { MUI, ThemeMode } from 'ci-esi-web-shared';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectPriceFeed } from 'app/containers/SocketHandler/selectors';
import { formatByLocale } from 'helpers/formatters';
import { translations } from 'locales/i18n';
import { colors } from 'styles/theme/colors';

import { HeaderItem } from '../HeaderItem';

const numberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const PriceFeedComponent = () => {
  const theme = MUI.useTheme();
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;
  const { t } = useTranslation();
  const priceFeed = useSelector(selectPriceFeed);

  return (
    <>
      <HeaderItem
        labelSx={{ lineHeight: '15px', color: isDarkMode ? colors.smokeScreen : colors.grey40 }}
        readOnly
        isPriceFeed
        tooltipText={t(translations.PRICE.TOOLTIP_TEXT)}
        label={t(translations.PRICE.WTI, {
          value: priceFeed?.WTI ? formatByLocale(priceFeed.WTI, numberFormatOptions) : t(translations.COMMON.NA),
        })}
        testId={TestLocators.Header_WTI}
      />
      <MUI.Divider orientation="vertical" sx={{ margin: '2px 8px', height: '16px', backgroundColor: colors.ebony }} />
      <HeaderItem
        labelSx={{ lineHeight: '15px', color: isDarkMode ? colors.smokeScreen : colors.grey40 }}
        readOnly
        isPriceFeed
        tooltipText={t(translations.PRICE.TOOLTIP_TEXT)}
        label={t(translations.PRICE.HENRY_HUB, {
          value: priceFeed?.HenryHub
            ? formatByLocale(priceFeed.HenryHub, numberFormatOptions)
            : t(translations.COMMON.NA),
        })}
        testId={TestLocators.Header_HH}
      />
    </>
  );
};

export const PriceFeed = PriceFeedComponent;
